import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './modules';
import { createStore } from 'redux';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['loginUserData', 'permission'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer);

export default store;
